export default function ErrorPage() {
    return (
        <>
            <div>
                <h1>Woh!</h1>
                <p>Errors...</p>
            </div>
        </>
    );
}
